import React from "react";
import {
  formatDuration,
  getDueAt,
  getOpenStartDate,
  getSlaHours,
} from "../utils/uaucUnresolvedUtils";

function getRiskClass(value, severity) {
  const sev = String(severity || "").toLowerCase();

  if (Number(value) >= 4 || sev.includes("critical")) {
    return "bg-red-600 text-white ring-red-600";
  }

  if (Number(value) >= 3 || sev.includes("high")) {
    return "bg-red-100 text-red-800 ring-red-200";
  }

  if (
    Number(value) >= 2 ||
    sev.includes("medium") ||
    sev.includes("moderate")
  ) {
    return "bg-orange-100 text-orange-800 ring-orange-200";
  }

  if (Number(value) >= 1 || sev.includes("low")) {
    return "bg-yellow-100 text-yellow-800 ring-yellow-200";
  }

  return "bg-slate-100 text-slate-700 ring-slate-200";
}

export default function UAUCObservationTable({ items = [], onOpenEdit }) {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm">
        <thead>
          <tr className="border-y border-slate-200 bg-slate-50 text-left text-xs font-black uppercase tracking-wide text-slate-500">
            <th className="px-4 py-3">Opened</th>
            <th className="px-4 py-3">Age</th>
            <th className="px-4 py-3">SLA</th>
            <th className="px-4 py-3">Observer</th>
            <th className="px-4 py-3">Area</th>
            <th className="px-4 py-3">Risk</th>
            <th className="px-4 py-3">Status</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-slate-100 bg-white">
          {items.map((item, index) => {
            const opened = getOpenStartDate(item);
            const openedDate = opened ? new Date(opened) : null;
            const dueAt = getDueAt(item);
            const overdue = dueAt ? Date.now() > dueAt.getTime() : false;
            const slaHours = getSlaHours(item);

            const riskValue = item?.riskValue?.value || "";
            const riskSeverity = item?.riskValue?.severity || "";
            const riskLabel =
              riskValue && riskSeverity
                ? `${riskValue} (${riskSeverity})`
                : riskValue || riskSeverity || "-";

            return (
              <tr
                key={item?._id || index}
                onClick={() => onOpenEdit?.(item)}
                className={`cursor-pointer transition hover:bg-sky-50 ${
                  index % 2 === 0 ? "bg-white" : "bg-slate-50/60"
                }`}
              >
                <td className="whitespace-nowrap px-4 py-3 font-bold text-slate-800">
                  {openedDate ? openedDate.toLocaleDateString() : "-"}
                </td>

                <td className="whitespace-nowrap px-4 py-3 font-semibold text-slate-600">
                  {opened
                    ? formatDuration(Date.now() - new Date(opened).getTime())
                    : "-"}
                </td>

                <td className="whitespace-nowrap px-4 py-3">
                  {dueAt ? (
                    <span
                      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-black ring-1 ${
                        overdue
                          ? "bg-red-50 text-red-700 ring-red-200"
                          : "bg-emerald-50 text-emerald-700 ring-emerald-200"
                      }`}
                    >
                      {overdue ? "Overdue" : "On Time"} · {slaHours}h
                    </span>
                  ) : (
                    <span className="text-slate-400">-</span>
                  )}
                </td>

                <td className="px-4 py-3 font-semibold text-slate-700">
                  {item?.observer?.name || "-"}
                </td>

                <td className="px-4 py-3 font-semibold text-slate-700">
                  {item?.area || "-"}
                </td>

                <td className="whitespace-nowrap px-4 py-3">
                  <span
                    className={`inline-flex rounded-full px-2.5 py-1 text-xs font-black ring-1 ${getRiskClass(
                      riskValue,
                      riskSeverity,
                    )}`}
                  >
                    {riskLabel}
                  </span>
                </td>

                <td className="whitespace-nowrap px-4 py-3">
                  <span className="inline-flex rounded-full bg-amber-50 px-2.5 py-1 text-xs font-black text-amber-700 ring-1 ring-amber-200">
                    {item?.status || "Open"}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
